/* eslint-disable max-len */
export default {
  header: '',
  item:
    '{{label}} ({{#helpers.formatNumber}}{{count}}{{/helpers.formatNumber}})',
  footer: '',
  seeAllOption: 'See all',
};



// WEBPACK FOOTER //
// ./src/widgets/menu-select/defaultTemplates.js